import {
  IS_ALPHANUMERIC_REGEX,
  IS_ALPHANUMERIC_WITH_DASH_REGEX,
  IS_ALPHANUMERIC_WITH_DASH_SPACE_REGEX,
  IS_ALPHANUMERIC_WITH_SPACE_REGEX,
  IS_ALPHA_REGEX,
} from "../../core/config/AppConstants";

//Apply validators only for react-final-form
export const ValidatorCustom = {
  passwordPatternValidator: (val: any) => {
    if (
      val &&
      val.match(
        /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,16}$/
      ) === null
    ) {
      return "Contain atleast one lowercase letter, one uppercase letter,Be at least 8 characters in length, Have at least one numerical character (0-9),Have at least one special character (#?!@$%^&*)";
    } else {
      return undefined;
    }
  },

  mobilePatternValidation: (val: any) => {
    if (val && val.match(/^\d{10}$/) === null) {
      return "Please enter 10 digits mobile number";
    } else {
      return undefined;
    }
  },

  emailPatternValidator: (val: any) => {
    if (
      val &&
      val
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ) === null
    ) {
      return "Please enter valid email";
    } else {
      return undefined;
    }
  },
  isAlphaPatternValidator: (val: any) => {
    if (val && val.toLowerCase().match(IS_ALPHA_REGEX) === null) {
      return "Only alphabets are allowed";
    } else {
      return undefined;
    }
  },
  isAlphaNumericPatternValidator: (val: any) => {
    if (val && val.toLowerCase().match(IS_ALPHANUMERIC_REGEX) === null) {
      return "Only alphabets and numbers are allowed";
    } else {
      return undefined;
    }
  },
  isAlphaNumericWithSpacePatternValidator: (val: any) => {
    if (
      val &&
      val.toLowerCase().match(IS_ALPHANUMERIC_WITH_SPACE_REGEX) === null
    ) {
      return "Only alphabets, numbers and space are allowed";
    } else {
      return undefined;
    }
  },
  isAlphaNumericWithDashPatternValidator: (val: any) => {
    if (
      val &&
      val.toLowerCase().match(IS_ALPHANUMERIC_WITH_DASH_REGEX) === null
    ) {
      return "Only alphabets, numbers, dash and hyphens are allowed";
    } else {
      return undefined;
    }
  },
  isAlphaNumericDashSpacePatternValidator: (val: any) => {
    if (
      val &&
      val.toLowerCase().match(IS_ALPHANUMERIC_WITH_DASH_SPACE_REGEX) === null
    ) {
      return "Only alphabets, numbers, dash hyphens and space are allowed";
    } else {
      return undefined;
    }
  },

  whiteSpacePatterValidator: (
    val: any,
    formFields?: any,
    currentField?: any
  ) => {
    if (val && /\s/.test(val)) {
      return `${
        currentField?.name
          ? currentField.name + " should not contain white space"
          : "White space is not allowed"
      }`;
    } else {
      return undefined;
    }
  },
};
